import DesktopMenu from './DesktopMenu';
import MobileMenu from './MobileMenu';
import TopMenu from './TopMenu';

const Navbar = () => (
  <nav className="relative bg-white border-b z-40">
    {/* Top Menu */}
    <TopMenu/>
    {/* Desktop Navigation */}
    <DesktopMenu />
    {/* Mobile Navigation */}
    <MobileMenu/>
  </nav>
);

export default Navbar;
